import React, { useState, useEffect } from "react";
import { ThumbsUp } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export function LikeButton({ dance, size = "md", stopNav = false }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [liked, setLiked] = useState(!!dance.liked_by_me);
  const [count, setCount] = useState(dance.like_count || 0);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setLiked(!!dance.liked_by_me); setCount(dance.like_count || 0); }, [dance.liked_by_me, dance.like_count]);

  const click = async (e) => {
    if (stopNav) e.stopPropagation();
    if (!user) {
      toast("Log in to vote", { description: "Create a free account to vote for your favourite dances." });
      navigate("/login", { state: { from: `/dances/${dance.slug}` } });
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post(`/dances/${dance.id}/like`);
      setLiked(data.liked); setCount(data.like_count);
    } catch { toast.error("Could not register your vote. Please try again."); }
    finally { setBusy(false); }
  };

  const pad = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3.5 py-2 text-sm";
  return (
    <button type="button" onClick={click} disabled={busy} data-testid={`dance-like-${dance.slug}`}
      aria-pressed={liked} aria-label={liked ? "Remove your vote" : "Vote for this dance"} title={liked ? "You voted for this dance" : "Vote for this dance"}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold transition ${pad} ${liked ? "bg-[#C85A32] border-[#C85A32] text-white" : "bg-white border-border text-[#5C4A42] hover:border-[#C85A32] hover:text-[#B04B26]"}`}>
      <ThumbsUp size={size === "sm" ? 14 : 16} fill={liked ? "currentColor" : "none"} />
      <span data-testid={`dance-like-count-${dance.slug}`}>{count}</span>
    </button>
  );
}
